export enum PlatformErrorCode {
    UNKNOWN = '',
    GAME_CENTER_NOT_ENABLED = 'GameCenterNote',
    NO_INTERNET_CONNECTION = 'AndroidInternet',
}

export const PLATFORM_ERROR_CODES: { [key in PlatformErrorCode]: string } = {
    [PlatformErrorCode.UNKNOWN]: '',
    [PlatformErrorCode.GAME_CENTER_NOT_ENABLED]: 'GameCenterNote',
    [PlatformErrorCode.NO_INTERNET_CONNECTION]: 'AndroidInternet',
};
